import cmaApi from "../../../../../api/cmaApi";
import { appRoutes } from "../../../../../routes/routes";
import LandingList from "../../LandingList";

const MetricsList = () => (
  <LandingList
    config={{
      title: "CMA · Chỉ số",
      listPath: appRoutes.CMA.LANDING.METRICS.LIST,
      addPath: appRoutes.CMA.LANDING.METRICS.ADD,
      queryKey: "cma_landing_metrics",
      getList: cmaApi.getLandingMetrics,
      editItem: cmaApi.editLandingMetric,
      deleteItem: cmaApi.deleteLandingMetric,
      titleField: "value",
      subtitleField: "label_vi",
    }}
  />
);

export default MetricsList;
